import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { BookingListProperties, BookingRights, BookingStatus, BookingTripDetailsSearch, BookingSearchListProperties, loginUserList, BookingListGetSearchProperties } from '../Models/BookingListProperties';
import { BookingListService } from '../Services/bookingList.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Countries } from '../Models/Countries';
import { SupplierData, SuppliersListProperties } from '../Models/SuppliersProperties';
import { SuppliersService } from '../Services/suppliers.service';
import { AirportService } from '../Services/airport.service';
import * as $ from 'jquery';
import { AirportProperties } from '../Models/AirportProperties';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { OfflineToOnlineProperties } from '../Models/TicketIssuanceProperties';

@Component({
    selector: 'app-back-office-accounts',
    templateUrl: './back-office-accounts.component.html',
    styleUrls: ['./back-office-accounts.component.css']
})
/** BackOfficeAccounts component*/
export class BackOfficeAccountsComponent {
  userId: number;
  agencyCodeList$: Observable<Agencies_BranchesProperties[]>;
  agencyList: Agencies_BranchesProperties[] = [];
  bookingstatusList$: Observable<BookingStatus[]>;
  obj = new SuppliersListProperties();
  spdata: SupplierData[] = [];
  tripdetailobj = new BookingTripDetailsSearch();
  airportGetList:AirportProperties[]=[];
  bookingsearchobj = new BookingSearchListProperties();
  bookingsearchobjforcall = new BookingSearchListProperties();
  bookingsearchobjnewforTSuse = new BookingSearchListProperties();
  bookingList: BookingListGetSearchProperties[] = [];
  bookedCount: number = 0;
  ticketedCount: number = 0;
  cancelCount: number = 0;
  voidCount: number = 0;
  bookedNoFareCount: number = 0;
  userlist: loginUserList[] = [];
  issuanceStaffList = [
    { name: 'Agent', value: 'Agent' },
    { name: 'Branch', value: 'Branch' },
    { name: 'Staff', value: 'Staff' }
  ];
  offlinetoOnline = new OfflineToOnlineProperties();
  collapsed = false;
  /** BookingListSearchCriteria ctor */
  constructor(private airportService: AirportService, private supplierservice: SuppliersService, private bookingListService: BookingListService, private http: HttpClient, private router: Router, private TripModal: NgbModal) {

  }
  ngOnInit() {
    this.LoadAgencyList();
    this.LoadBookingStatusList();
    this.getSupplierList();
    this.getDataAirportAll();

  }
  LoadBookingStatusList() {
    this.bookingListService.GetAllBookingStatus().subscribe((data) => {
      this.bookingstatusList$ = of(data);
    });
  }
  getSupplierList() {
    this.supplierservice.getSuppliersList().subscribe((data: SuppliersListProperties) => {
      if (data) {
        this.obj = data;
        this.spdata = this.obj.airSupplier
      }
      //console.log(data);
    })
  }

  getDataAirportAll() {
    this.airportService.GetAllAirport().subscribe((data) => {


      this.airportGetList = data;

    });
  }
  LoadAgencyList() {
    try {
      let loginAgency = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("") != "") && (localStorage.getItem("AgencyId") != null)) {
        loginAgency = localStorage.getItem("AgencyId")
        if ((localStorage.getItem("UserId") != undefined) && (localStorage.getItem("UserId") != "") && (localStorage.getItem("UserId") != null))
          this.userId = Number(localStorage.getItem("UserId"));
        if (this.userId != 0) {
          this.bookingListService.GetAllAgencies(loginAgency, this.userId).subscribe((data) => {
            this.agencyList = data;
            this.agencyCodeList$ = of(data);
          });
        }
      }
    }
    catch (e) {
    }
  }
  trippopup(triptarget) {
    this.TripModal.open(triptarget, {
      size: 'md',
    })
  }
  clickTripDetailsBtn() {
    if (this.tripdetailobj.fromAirport == "" || this.tripdetailobj.fromAirport == null || this.tripdetailobj.fromAirport == undefined) {
      document.getElementById("frommessageair").innerHTML = "Required Mobile";
      document.getElementById("clasairrborderfrom").classList.add("newRequired-BoxColor");
      document.getElementById("labelairfrom").style.color = "red";


      setTimeout(function () {

        document.getElementById("frommessageair").innerHTML = "";
        document.getElementById("clasairrborderfrom").classList.remove("newRequired-BoxColor");
        document.getElementById("labelairfrom").style.color = "";

      }

        , 5000);
    }
    if (this.tripdetailobj.toAirport == "" || this.tripdetailobj.toAirport == null || this.tripdetailobj.toAirport == undefined) {
      document.getElementById("tomessageair").innerHTML = "Required Mobile";
      document.getElementById("clasairrborderto").classList.add("newRequired-BoxColor");
      document.getElementById("labelairto").style.color = "red";


      setTimeout(function () {

        document.getElementById("tomessageair").innerHTML = "";
        document.getElementById("clasairrborderto").classList.remove("newRequired-BoxColor");
        document.getElementById("labelairto").style.color = "";

      }

        , 5000);
    }
    if (this.tripdetailobj.journeyType == "" || this.tripdetailobj.journeyType == null || this.tripdetailobj.journeyType == undefined) {
      document.getElementById("messageJourney").innerHTML = "Required Mobile";
      document.getElementById("clasJourneyborderto").classList.add("newRequired-BoxColor");
      document.getElementById("labelJourney").style.color = "red";


      setTimeout(function () {

        document.getElementById("messageJourney").innerHTML = "";
        document.getElementById("clasJourneyborderto").classList.remove("newRequired-BoxColor");
        document.getElementById("labelJourney").style.color = "";

      }

        , 5000);
    }
    if (this.tripdetailobj.fromAirport == "" || this.tripdetailobj.fromAirport == null || this.tripdetailobj.fromAirport == undefined
      || this.tripdetailobj.toAirport == "" || this.tripdetailobj.toAirport == null || this.tripdetailobj.toAirport == undefined ||
      this.tripdetailobj.journeyType == "" || this.tripdetailobj.journeyType == null || this.tripdetailobj.journeyType == undefined) {
      return;
    }
    this.bookingsearchobj.trip = `${this.tripdetailobj.fromAirport} to${this.tripdetailobj.toAirport} (${this.tripdetailobj.journeyType})`;
    this.TripModal.dismissAll();
  }

  SearchData() {

    this.bookingsearchobj.agencyId = localStorage.getItem("AgencyId");
    this.bookingsearchobj.userId = Number(localStorage.getItem("UserId"));
    this.bookingsearchobjnewforTSuse = JSON.parse(JSON.stringify(this.bookingsearchobj));
    this.bookingsearchobjforcall = JSON.parse(JSON.stringify(this.bookingsearchobj));
    this.bookingsearchobjforcall.rowCount = 0;
    if (this.bookingsearchobjforcall.byAgency != "" && this.bookingsearchobjforcall.loginUserId != undefined) {
      this.bookingsearchobjforcall.byagencyUser = this.bookingsearchobjforcall.byAgency;
      this.bookingsearchobjforcall.byAgency = "";
      this.bookingsearchobjnewforTSuse.byagencyUser = this.bookingsearchobjnewforTSuse.byAgency;
      this.bookingsearchobjnewforTSuse.byAgency = "";
    }
    
    if (this.bookingsearchobjforcall.bookingID == null || this.bookingsearchobjforcall.bookingID == undefined) {
      this.bookingsearchobjforcall.bookingID = 0;
    }
    if (this.bookingsearchobjforcall.loginUserId == null || this.bookingsearchobjforcall.loginUserId == undefined) {
      this.bookingsearchobjforcall.loginUserId = 0;
    }
    if (this.bookingsearchobjforcall.fromBookingDate == null || this.bookingsearchobjforcall.fromBookingDate == undefined) {
      this.bookingsearchobjforcall.fromBookingDate = "";
    }
    if (this.bookingsearchobjforcall.toBookingDate == null || this.bookingsearchobjforcall.toBookingDate == undefined) {
      this.bookingsearchobjforcall.toBookingDate = "";
    }
    if (this.bookingsearchobjforcall.supplier == null || this.bookingsearchobjforcall.supplier == undefined) {
      this.bookingsearchobjforcall.supplier = "";
    }
    if (this.bookingsearchobjforcall.pnr == null || this.bookingsearchobjforcall.pnr == undefined) {
      this.bookingsearchobjforcall.pnr = "";
    }
    if (this.bookingsearchobjforcall.travelDate == null || this.bookingsearchobjforcall.travelDate == undefined) {
      this.bookingsearchobjforcall.travelDate = "";
    }
    if (this.bookingsearchobjforcall.tkt == null || this.bookingsearchobjforcall.tkt == undefined) {
      this.bookingsearchobjforcall.tkt = "";
    }
    if (this.bookingsearchobjforcall.trip == null || this.bookingsearchobjforcall.trip == undefined) {
      this.bookingsearchobjforcall.trip = "";
    }
    if (this.bookingsearchobjforcall.name == null || this.bookingsearchobjforcall.name == undefined) {
      this.bookingsearchobjforcall.name = "";
    }
    if (this.bookingsearchobjforcall.byAgency == null || this.bookingsearchobjforcall.byAgency == undefined || this.bookingsearchobjforcall.byAgency == "") {
      this.bookingsearchobjforcall.byAgency = "";
      
    }
    if (this.bookingsearchobjforcall.byagencyUser == null || this.bookingsearchobjforcall.byagencyUser == undefined ) {
      this.bookingsearchobjforcall.byagencyUser = "";
      this.bookingsearchobjforcall.loginUserId = 0;
    }
    if (this.bookingsearchobjforcall.bookingStatus == null || this.bookingsearchobjforcall.bookingStatus == undefined) {
      this.bookingsearchobjforcall.bookingStatus = 0;
    }
    if (this.bookingsearchobjforcall.issuanceStaff == null || this.bookingsearchobjforcall.issuanceStaff == undefined) {
      this.bookingsearchobjforcall.issuanceStaff = "";
    }
    this.bookingListService.GetB2BBackOfficebookinglistBySearchCriteria(this.bookingsearchobjforcall).subscribe((data) => {
      this.bookingList = data;
      const counts = {
        booked: 0,
        ticketed: 0,
        cancelled: 0,
        void: 0,
        bookedNoFare: 0
      };

      this.bookingList.forEach(b => {

        if (b.bookingStatus === 'Booked') counts.booked++;

        else if (b.bookingStatus === 'Ticketed') counts.ticketed++;

        else if (b.bookingStatus === 'Cancelled') counts.cancelled++;

        else if (b.bookingStatus === 'Void') counts.void++;

        else if (b.bookingStatus === 'Booked-NoFare') counts.bookedNoFare++;

      });

      this.bookedCount = counts.booked;
      this.ticketedCount = counts.ticketed;
      this.cancelCount = counts.cancelled;
      this.voidCount = counts.void;
      this.bookedNoFareCount = counts.bookedNoFare;
      /*this.bookingsearchobj = new BookingSearchListProperties();*/
      document.querySelector(".LoadButton").classList.remove("activeLoading");
    })
  }
  nextSearchData() {

    this.bookingsearchobjnewforTSuse.rowCount = this.bookingList.length;
    if (this.bookingsearchobjnewforTSuse.bookingID == null || this.bookingsearchobjnewforTSuse.bookingID == undefined) {
      this.bookingsearchobjnewforTSuse.bookingID = 0;
    }
    if (this.bookingsearchobjnewforTSuse.loginUserId == null || this.bookingsearchobjnewforTSuse.loginUserId == undefined) {
      this.bookingsearchobjnewforTSuse.loginUserId = 0;
    }
    if (this.bookingsearchobjnewforTSuse.fromBookingDate == null || this.bookingsearchobjnewforTSuse.fromBookingDate == undefined) {
      this.bookingsearchobjnewforTSuse.fromBookingDate = "";
    }
    if (this.bookingsearchobjnewforTSuse.toBookingDate == null || this.bookingsearchobjnewforTSuse.toBookingDate == undefined) {
      this.bookingsearchobjnewforTSuse.toBookingDate = "";
    }
    if (this.bookingsearchobjnewforTSuse.supplier == null || this.bookingsearchobjnewforTSuse.supplier == undefined) {
      this.bookingsearchobjnewforTSuse.supplier = "";
    }
    if (this.bookingsearchobjnewforTSuse.pnr == null || this.bookingsearchobjnewforTSuse.pnr == undefined) {
      this.bookingsearchobjnewforTSuse.pnr = "";
    }
    if (this.bookingsearchobjnewforTSuse.travelDate == null || this.bookingsearchobjnewforTSuse.travelDate == undefined) {
      this.bookingsearchobjnewforTSuse.travelDate = "";
    }
    if (this.bookingsearchobjnewforTSuse.tkt == null || this.bookingsearchobjnewforTSuse.tkt == undefined) {
      this.bookingsearchobjnewforTSuse.tkt = "";
    }
    if (this.bookingsearchobjnewforTSuse.trip == null || this.bookingsearchobjnewforTSuse.trip == undefined) {
      this.bookingsearchobjnewforTSuse.trip = "";
    }
    if (this.bookingsearchobjnewforTSuse.name == null || this.bookingsearchobjnewforTSuse.name == undefined) {
      this.bookingsearchobjnewforTSuse.name = "";
    }
    if (this.bookingsearchobjnewforTSuse.byAgency == null || this.bookingsearchobjnewforTSuse.byAgency == undefined || this.bookingsearchobjnewforTSuse.byAgency == "") {
      this.bookingsearchobjnewforTSuse.byAgency = "";

    }
    if (this.bookingsearchobjnewforTSuse.byagencyUser == null || this.bookingsearchobjnewforTSuse.byagencyUser == undefined) {
      this.bookingsearchobjnewforTSuse.byagencyUser = "";
      this.bookingsearchobjnewforTSuse.loginUserId = 0;
    }
    if (this.bookingsearchobjnewforTSuse.bookingStatus == null || this.bookingsearchobjnewforTSuse.bookingStatus == undefined) {
      this.bookingsearchobjnewforTSuse.bookingStatus = 0;
    }
    if (this.bookingsearchobjnewforTSuse.issuanceStaff == null || this.bookingsearchobjnewforTSuse.issuanceStaff == undefined) {
      this.bookingsearchobjnewforTSuse.issuanceStaff = "";
    }
    this.bookingListService.GetB2BBackOfficebookinglistBySearchCriteria(this.bookingsearchobjnewforTSuse).subscribe((data) => {
      document.querySelector(".NextButton").classList.remove("activeLoadings");
      if (data.length > 0) {


        let listnew: BookingListGetSearchProperties[] = [];
        listnew = data;
        /*  this.bookingList = [...listnew]*/
        /*      this.bookingList= this.bookingList.map(s => { return { ...s, data } });*/
        for (let i = 0; i < listnew.length; i++) {
          let objs = new BookingListGetSearchProperties();
          objs.agencyId = listnew[i].agencyId;
          objs.bookingDate = listnew[i].bookingDate;
          objs.bookingID = listnew[i].bookingID;
          objs.bookingStatus = listnew[i].bookingStatus;
          objs.name = listnew[i].name;
          objs.pnr = listnew[i].pnr;
          objs.requestTypeName = listnew[i].requestTypeName;
          objs.supplier = listnew[i].supplier;
          objs.tkt = listnew[i].tkt;
          objs.travelDate = listnew[i].travelDate;
          objs.trip = listnew[i].trip;
          objs.amount = listnew[i].amount;
          objs.loginName = listnew[i].loginName;
          this.bookingList.push(objs);
        }
        //console.log(this.bookingList);
      }
      else {
        document.getElementById("Message_next").innerHTML = "No More Data";
        document.getElementById("errortext").classList.remove("hidemarginss");
        setTimeout(function () {


          document.getElementById("Message_next").innerHTML = "";
          document.getElementById("errortext").classList.add("hidemarginss");

        }

          , 5000);
      }
      })
    
  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-checkbox-icon").css({ "border": "1px solid black" });
    $(".dx-button-content").css({ "background-color": "var(--first-color-second)" });
    $(".dx-icon.dx-icon-export-to").css({ "color": "white" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function (options) {
        const excelCell = options;
        // exce = { name: 'Arial', size: 12 };
        // excelCell.alignment = { horizontal: 'left' };
      }
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'B2BBackOfficeReport.xlsx');
        });
    });
    e.cancel = true;
  }
  infoText(currentPageNumber, totalPageCount, totalRowCount) {
    let pagenum = currentPageNumber;

    //let number = this.dataGrid.instance.pageCount();
    if (pagenum == totalPageCount) {
      //console.log('totalPageCount', totalPageCount);
      //console.log('pagenum', pagenum);
      if (totalRowCount > 1) {
        document.getElementById('buttonnext').classList.remove('hiddenclass');
      }
    }
    else {
      try {
        document.getElementById('buttonnext').classList.add('hiddenclass');
      }
      catch (ex) { console.log(ex); }

    }

  }
  NextButtonClick() {
    document.querySelector(".NextButton").classList.add("activeLoadings");
    this.nextSearchData();
  }
  LoadButtonClick() {
    document.querySelector(".LoadButton").classList.add("activeLoading");
    this.SearchData();
  }
  Edit_Click(getdata) {
    try {
      //if (getdata.bookingStatus == "Requested") {
      //  this.bookingListService.getBookingrequestId(getdata.bookingID).subscribe((data) => {
      //    if (data.requestTypeName == "Online Ticket Request") {
      //      localStorage.setItem("bookingID", getdata.bookingID);
      //      this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
      //      this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
      //      this.offlinetoOnline.TicketIssueReqFromOffline = true;
      //      this.offlinetoOnline.fromroutePageNoright = "B2BBackofficePage";
      //      this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
      //      localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
      //      this.router.navigateByUrl('/ticket-issuance');
      //    }
      //    else if (data.requestTypeName == "Online Void Request") {
      //      localStorage.setItem("bookingID", getdata.bookingID);
      //      this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
      //      this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
      //      this.offlinetoOnline.VoidReqFromOffline = true;
      //      this.offlinetoOnline.fromroutePageNoright = "B2BBackofficePage";
      //      this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
      //      localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
      //      this.router.navigateByUrl('/ticket-issuance');
      //    }
      //    else if (data.requestTypeName == "Online PNR Cancel Request") {
      //      localStorage.setItem("bookingID", getdata.bookingID);
      //      this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
      //      this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
      //      this.offlinetoOnline.PNRReqFromOffline = true;
      //      this.offlinetoOnline.fromroutePageNoright = "B2BBackofficePage";
      //      this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
      //      localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
      //      this.router.navigateByUrl('/ticket-issuance');
      //    }
      //    else if (data.requestTypeName == "Online Refund Request") {
      //      localStorage.setItem("bookingID", getdata.bookingID);
      //      this.offlinetoOnline.RequestTypeIdOffline = data.requestTypeName;
      //      this.offlinetoOnline.AgencyTicketReqFromOffline = data.offlineagencyId;
      //      this.offlinetoOnline.RefundReqFromOffline = true;
      //      this.offlinetoOnline.fromroutePageNoright = "B2BBackofficePage";
      //      this.offlinetoOnline.OfflineId = Number(data.offlinebookingId);
      //      localStorage.setItem('OfflineToOnline', JSON.stringify(this.offlinetoOnline));
      //      this.router.navigateByUrl('/ticket-issuance');
      //    }
      //  })

      //}
/*      else {*/
        localStorage.setItem('bookingID', getdata.bookingID);
        localStorage.setItem("fromroutePageNoright", "B2BBackofficePage");
        this.router.navigateByUrl('/ticket-issuance');
     /* }*/

    }
    catch (e) { }
  }
  getlistofUsers(str) {
    this.userlist = [];
    if (str == null) {
      return;
    }
  /*  if (str.includes("B")) {*/


      this.bookingListService.GetAllAgencyUserName(str).subscribe((data) => {
        //console.log(data);
        if (data.length > 0) {
          this.userlist = data;
          //console.log(this.userlist);
        }
      })
/*    }*/
    }

}
